export enum CurrencyCode {
	EUR = "EUR",
	USD = "USD",
	GBP = "GBP",
	JPY = "JPY",
	MXN = "MXN"
}
